import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sPerson = _resolveComponent("sPerson")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "Agregar persona",
    modelValue: _ctx.dialog_register,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dialog_register) = $event)),
    "close-on-click-modal": false,
    class: "bg-light rounded",
    top: "2vh",
    width: "50%"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_sPerson, { onOnResponse: _ctx.onResponse }, null, 8, ["onOnResponse"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}